export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/business_names_slogans.14cf6f3.svg";